import SallePrelevement from '@/views/tableau-de-bord/salle-prelevement'
import ReceptionEchantillons from '@/views/tableau-de-bord/reception-echantillons'
import PaillasseAnalyses from '@/views/tableau-de-bord/paillasse-analyses'

// LAB-UI-2 : une seule carte « Laboratoire » à onglets chronologiques, comme l'ancien tableau. LAB-009 : flux linéaire —
// prélevé au laboratoire => Technique, prélevé en unité de soins => Réception => Technique ; technique démarrée puis
// terminée (temps mesuré) => Saisie ; résultat saisi => validation biologique (carte à part). Indicateurs en KPI (LAB-UI-3).
export const ONGLETS = [
    { id: 'prelevement', nom: 'Prélèvement', icone: 'fa-vial', titre: 'Salle de prélèvement', description: 'Bulletins validés en caisse à prélever. Prélevé ici, le bon passe en Technique ; prélevé en unité de soins, il arrive en Réception.' },
    { id: 'reception', nom: 'Réception', icone: 'fa-inbox', titre: 'Réception des échantillons', description: 'Échantillons apportés au laboratoire (unité de soins ou structure externe) : qui les a apportés, à quelle heure ; accepté => Technique, rejet motivé => nouveau prélèvement.' },
    { id: 'technique', nom: 'Technique', icone: 'fa-flask', titre: 'Technique — analyses à traiter', description: 'Démarrer puis terminer la technique de chaque analyse (temps mesuré), par analyse ou pour tout un patient ; terminée => Saisie.' },
    { id: 'saisie', nom: 'Saisie', icone: 'fa-keyboard', titre: 'Saisie des résultats', description: 'Analyses techniquées à saisir ; sans modèle de résultat, créez-le d\'ici. Résultat enregistré => validation biologique.' }
]

const MEMO = 'clinicaa.laboratoire.onglet'

export default {
    name: 'laboratoire-circuit',
    components: { SallePrelevement, ReceptionEchantillons, PaillasseAnalyses },
    props: [],
    data() {
        return {
            onglet: 'prelevement', onglets: ONGLETS, cle: 0
        }
    },

    watch: {

    },

    computed: {
        onglet_courant() {
            return this.onglets.filter(item => item.id === this.onglet)[0] || this.onglets[0]
        },

        // Libellé du rôle actif (« Technicien Supérieur de Laboratoire », « Médecin biologiste »…)
        libelle_role() {
            const role = (this.$store && this.$store.getters) ? this.$store.getters['activeRole'] : null
            return role ? (role.description || role.nom || '') : ''
        }
    },

    mounted() {
        this.restaurer()
    },

    methods: {
        choisir(id) {
            if (this.onglet === id || !this.onglets.some(item => item.id === id)) return
            this.onglet = id
            this.memoriser()
        },

        // Remonte l'onglet courant (la clé change, le contenu est recréé et se recharge)
        rafraichir() {
            this.cle++
        },

        memoriser() {
            try {
                if (typeof window !== 'undefined' && window.sessionStorage) window.sessionStorage.setItem(MEMO, this.onglet)
            } catch (erreur) {
                // stockage de session indisponible : l'onglet n'est simplement pas mémorisé
            }
        },

        restaurer() {
            try {
                const memo = (typeof window !== 'undefined' && window.sessionStorage) ? window.sessionStorage.getItem(MEMO) : null
                if (memo && this.onglets.some(item => item.id === memo)) this.onglet = memo
            } catch (erreur) {
                // stockage de session indisponible
            }
        }
    }
}
